import { JFSRequest, executeRequest } from '@jfs/network'
import { EmType } from '../screens/EntityManagement'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('getDocumentImageRequest data:', data)
  return data
}

const getViewDocumentListRequest = (entityIdentificationNumber: string, tokens: any, type: string) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getDocumentsList,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      entityIdentificationNumber: entityIdentificationNumber,
      ...(type?.length > 0 && type === EmType.Search && { kycType: 'ENTITY_SEARCH' }),
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getViewDocumentListRequest }
